import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../../_metronic/layout/core'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify';
import { MenuComponent } from '../../../../_metronic/assets/ts/components'
import { Modal, Button, Form } from 'react-bootstrap';
import { KTCard, KTCardBody, KTIcon, Loader, toAbsoluteUrl } from '../../../../_metronic/helpers'

import './stocks.css';
import { clearState, getVariantList, postStock } from './stockActions';
import { patchVariant, clearState as clearProductState } from '../../catalog-management/product/productActions';
import AluminiumStockCard from './AluminiumStockCard';

const Stocks = (props) => {
    //inputs from url
    const params = useParams();
    const intl = useIntl()
    MenuComponent.reinitialization();

    //inputs from redux
    const {
        variantList,
        loading,
        success,
        productSuccess,
        productLoading
    } = props;

    //actions
    const {
        clearState,
        getVariantList,
        postStock,
        patchVariant,
        clearProductState
    } = props;

    const [filteredList, setFilteredList] = useState([]);
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedItemId, setSelectedItemId] = useState(null);
    const [confirmAction, setConfirmAction] = useState(null);
    const [editForm, setEditForm] = useState({
        redThreshold: 0,
        yellowThreshold: 0,
        adjustmentAmount: 1
    });

    const selectedItem = variantList && selectedItemId ? variantList.find(item => item.id === selectedItemId) : null;

    useEffect(() => {

        getVariantList();

        return () => {
            clearState()
            clearProductState()
        }
    }, []);

    useEffect(() => {
        MenuComponent.reinitialization();
        setFilteredList(variantList);
    }, [variantList])


    useEffect(() => {
        if (success) {
            toast.success(intl.formatMessage({ id: success }));
        }
    }, [success])

    useEffect(() => {
        if (productSuccess) {
            toast.success(intl.formatMessage({ id: productSuccess }));
            clearProductState();
        }
    }, [productSuccess])

    const progressColorClass = (color) => {
        if (color == 1)
            return "bg-danger";

        if (color == 0)
            return "bg-warning";

        return "bg-success";
    }

    const progressPercentage = (item) => {
        return item.percentage > 100 ? "100%" : item.percentage + "%";
    }

    const handleEditClick = (item) => {
        setSelectedItemId(item.id);
        setConfirmAction(null);
        setEditForm({
            redThreshold: item.redThreshold || 0,
            yellowThreshold: item.yellowThreshold || 0,
            adjustmentAmount: 1
        });
        setShowEditModal(true);
    }

    const handleSaveThresholds = () => {
        if (!selectedItem) return;

        const update = {
            redThreshold: editForm.redThreshold,
            yellowThreshold: editForm.yellowThreshold
        };
        
        patchVariant(selectedItem.productId, selectedItem.id, update);
    }

    const handleStockOperation = (isIncrease) => {
        if (!selectedItem) return;
        
        const action = isIncrease ? 'increase' : 'decrease';
        
        if (confirmAction === action) {
            const quantity = isIncrease ? Number(editForm.adjustmentAmount) : -Number(editForm.adjustmentAmount);
            postStock(selectedItem.id, quantity);
            setConfirmAction(null);
        } else {
            setConfirmAction(action);
        }
    }

    const cancelConfirm = () => setConfirmAction(null);

    const breadcrumbs = [
        {
            title: intl.formatMessage({ id: 'STOCK.MANAGEMENT.TITLE' }),
            path: '/stock-management/stocks',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        }
    ]

    const onSearch = (value) => {
        const timeOutId = setTimeout(() => {
            var newList = variantList.filter((item) => {
                return item.productName.toLowerCase().includes(value.toLowerCase()) 
                || item.productCode.toLowerCase().includes(value.toLowerCase()) 
                || item.code.toLowerCase().includes(value.toLowerCase()) 
                || item.categoryName.toLowerCase().includes(value.toLowerCase());
            });
            setFilteredList(newList);
        }, 400);
        return () => clearTimeout(timeOutId);
    }

    const renderProductImage = (item) => {
        if (item && item.productImageLink) {
            return (
                <div className='symbol symbol-45px me-5'>
                    <img src={item.productImageLink} alt='' />
                </div>
            )
        }

        return (
            <div className='symbol symbol-45px me-5'>
                <KTIcon iconName='parcel-tracking' className='fs-3x' />
            </div>
        )
    }

    const renderEditModal = () => {
        if (!selectedItem) return null;

        const adjustment = Number(editForm.adjustmentAmount) || 0;
        const stockAfterDecrease = (selectedItem.stockQuantity || 0) - adjustment;
        const stockAfterIncrease = (selectedItem.stockQuantity || 0) + adjustment;

        return (
            <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered dialogClassName="mw-600px">
                <Modal.Header closeButton>
                    <Modal.Title className="d-flex align-items-center">
                        {selectedItem.productImageLink ? (
                            <div className='symbol symbol-40px me-3'>
                                <img src={selectedItem.productImageLink} alt='' className="h-100" />
                            </div>
                        ) : (
                            <div className='symbol symbol-40px me-3'>
                                <KTIcon iconName='parcel-tracking' className='fs-1' />
                            </div>
                        )}
                        <div className="d-flex flex-column">
                            <span className="fs-5 fw-bolder">{intl.formatMessage({ id: 'STOCK.FIELD.EDIT_TITLE' })}</span>
                            <span className="fs-7 fw-normal text-gray-600">
                                {selectedItem.productName} - {selectedItem.name} <span className="text-muted">({selectedItem.code})</span>
                            </span>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-8">
                        <h4 className="mb-6 text-gray-800 d-flex align-items-center">
                            <KTIcon iconName='setting-2' className='fs-2 me-2 text-primary' />
                            {intl.formatMessage({ id: 'STOCK.FIELD.THRESHOLDS' })}
                        </h4>
                        <div className="row g-5">
                            <div className="col-md-6">
                                <Form.Group>
                                    <Form.Label className="fw-bold text-gray-700">{intl.formatMessage({ id: 'STOCK.FIELD.YELLOWTHRESHOLD' })}</Form.Label>
                                    <Form.Control 
                                        type="number" 
                                        className="bg-light-warning border-warning"
                                        value={editForm.yellowThreshold} 
                                        onChange={(e) => setEditForm({...editForm, yellowThreshold: e.target.value})}
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group>
                                    <Form.Label className="fw-bold text-gray-700">{intl.formatMessage({ id: 'STOCK.FIELD.REDTHRESHOLD' })}</Form.Label>
                                    <Form.Control 
                                        type="number" 
                                        className="bg-light-danger border-danger"
                                        value={editForm.redThreshold} 
                                        onChange={(e) => setEditForm({...editForm, redThreshold: e.target.value})}
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-12 mt-4 d-flex justify-content-end">
                                <Button variant="primary" onClick={handleSaveThresholds} className="" disabled={productLoading}>
                                    {!productLoading && <KTIcon iconName='file-down' className='fs-2' />}
                                    {productLoading && <span className='indicator-progress' style={{ display: 'block' }}>
                                        {intl.formatMessage({ id: 'GENERAL.WAIT' })} <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                    </span>}
                                    {!productLoading && intl.formatMessage({ id: 'GENERAL.SAVE' })}
                                </Button>
                            </div>
                        </div>
                    </div>

                    <div className="separator separator-dashed my-6"></div>

                    <div className="mb-2">
                        <h4 className="mb-4 text-gray-800 d-flex align-items-center">
                            <KTIcon iconName='cube-3' className='fs-2 me-2 text-info' />
                            {intl.formatMessage({ id: 'STOCK.FIELD.STOCK' })}
                        </h4>
                        <div className="d-flex align-items-center justify-content-center mb-4 bg-light p-3 rounded">
                            <div className="d-flex flex-column text-center">
                                <span className="text-gray-600 fs-7 fw-bold">{intl.formatMessage({ id: 'STOCK.FIELD.CURRENTSTOCKQUANTITY' })}</span>
                                <span className="fw-bolder fs-3x text-gray-800">{selectedItem.stockQuantity}</span>
                            </div>
                        </div>
                        
                        <div className="d-flex flex-column">
                            <Form.Label className="fw-bold text-gray-700 mb-2 text-center">{intl.formatMessage({ id: 'STOCK.FIELD.ADJUSTMENT' })}</Form.Label>
                            <div className="input-group mb-3">
                                {confirmAction === 'decrease' ? (
                                    <>
                                        <Button variant="danger" onClick={() => handleStockOperation(false)} className="w-150px">
                                            <KTIcon iconName='check' className='fs-2' /> {intl.formatMessage({ id: 'GENERAL.YES' })}?
                                        </Button>
                                        <Button variant="light-danger" onClick={cancelConfirm} className="btn-icon ms-2">
                                            <KTIcon iconName='cross' className='fs-2' />
                                        </Button>
                                    </>
                                ) : (
                                    <Button variant="danger" onClick={() => handleStockOperation(false)} disabled={confirmAction === 'increase'}>
                                        <KTIcon iconName='minus' className='fs-2' /> {intl.formatMessage({ id: 'STOCK.FIELD.DECREASE' })} <span className="ms-1 opacity-75">({intl.formatMessage({ id: 'STOCK.FIELD.TO' })} {stockAfterDecrease})</span>
                                    </Button>
                                )}
                                
                                <Form.Control 
                                    type="number" 
                                    className="text-center fw-bold fs-5"
                                    value={editForm.adjustmentAmount}
                                    onChange={(e) => setEditForm({...editForm, adjustmentAmount: e.target.value})}
                                    disabled={confirmAction !== null}
                                />

                                {confirmAction === 'increase' ? (
                                    <>
                                        <Button variant="success" onClick={() => handleStockOperation(true)} className="w-150px">
                                            <KTIcon iconName='check' className='fs-2' /> {intl.formatMessage({ id: 'GENERAL.YES' })}?
                                        </Button>
                                        <Button variant="light-danger" onClick={cancelConfirm} className="btn-icon ms-2">
                                            <KTIcon iconName='cross' className='fs-2' />
                                        </Button>
                                    </>
                                ) : (
                                    <Button variant="success" onClick={() => handleStockOperation(true)} disabled={confirmAction === 'decrease'}>
                                        {intl.formatMessage({ id: 'STOCK.FIELD.INCREASE' })} <span className="me-1 opacity-75">({intl.formatMessage({ id: 'STOCK.FIELD.TO' })} {stockAfterIncrease})</span> <KTIcon iconName='plus' className='fs-2' />
                                    </Button>
                                )}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }

    return (
        <>

            <PageTitle breadcrumbs={breadcrumbs} >{intl.formatMessage({ id: 'STOCK.LIST.BREADCRUMB' })}</PageTitle>

            <AluminiumStockCard />

            <div className={`card `}>
                {/* begin::Header */}
                <div className='card-header border-0 pt-5 sticky-card-header'>
                    <h3 className='card-title align-items-start flex-column'>
                        <span className='card-label fw-bold fs-3 mb-1'>{intl.formatMessage({ id: 'STOCK.FIELD.LIST' })}</span>
                        <span className='text-muted mt-1 fw-semibold fs-7'>{`${variantList && variantList.length} ${intl.formatMessage({ id: 'STOCK.VARIANTS.LISTED' })}`}</span>
                    </h3>
                    <div className="d-flex align-items-center position-relative my-1">
                        <i className="ki-duotone ki-magnifier fs-1 position-absolute ms-6">
                            <span className="path1"></span>
                            <span className="path2"></span>
                        </i>
                        <input type="text" data-kt-user-table-filter="search" className="form-control form-control-solid w-250px ps-14" placeholder={intl.formatMessage({ id: 'STOCK.SEARCH' })} onChange={(e) => onSearch(e.target.value)} />
                    </div>
                </div>
                {/* end::Header */}
                {/* begin::Body */}
                <div className='card-body py-3'>
                    {/* begin::Table container */}
                    <div className='table-responsive'>
                        {/* begin::Table */}
                        <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                            {/* begin::Table head */}
                            <thead>
                                <tr className='fw-bold text-muted'>
                                    <th className='w-25px'>#</th>
                                    <th className='min-w-200px'>{intl.formatMessage({ id: 'STOCK.FIELD.PRODUCT-VARIANT' })}</th>
                                    <th className='min-w-100px'>{intl.formatMessage({ id: 'STOCK.FIELD.CODE' })}</th>
                                    <th className='min-w-100px'>{intl.formatMessage({ id: 'STOCK.FIELD.YELLOWTHRESHOLD' })}</th>
                                    <th className='min-w-100px'>{intl.formatMessage({ id: 'STOCK.FIELD.REDTHRESHOLD' })}</th>
                                    <th className='min-w-100px'>{intl.formatMessage({ id: 'STOCK.FIELD.AVAILABLESTOCK' })}</th>
                                    <th className='min-w-150px'>{intl.formatMessage({ id: 'STOCK.FIELD.STOCK' })}</th>
                                    <th className='min-w-100px'>{intl.formatMessage({ id: 'STOCK.FIELD.PROGRESS' })}</th>
                                    <th className='min-w-50px text-end'>{intl.formatMessage({ id: 'STOCK.FIELD.ACTIONS' })}</th>
                                </tr>
                            </thead>
                            {/* end::Table head */}
                            {/* begin::Table body */}
                            <tbody>
                                {filteredList && filteredList.map((item, index) => {
                                    return (
                                        <tr key={`variant_row_${index}`}>
                                            <td>
                                                {++index}
                                            </td>
                                            <td>
                                                <div className='d-flex align-items-center'>
                                                    {renderProductImage(item)}
                                                    <div className='d-flex justify-content-start flex-column'>
                                                        <Link to={`/catalog-management/products/${item.productId}/detail`} className='text-dark fw-bold text-hover-primary fs-6'>
                                                            {item.productName}
                                                        </Link>
                                                        <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                                            {item.name}
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <span className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                                    {item.productCode}
                                                </span>
                                                <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                                    {item.code}
                                                </span>
                                            </td>
                                            <td>
                                                <span className="badge badge-light-warning fw-bold fs-7">{item.yellowThreshold}</span>
                                            </td>
                                            <td>
                                                <span className="badge badge-light-danger fw-bold fs-7">{item.redThreshold}</span>
                                            </td>
                                            <td>
                                                <span className="badge badge-light-success fs-7 fw-bold">
                                                    {item.availableStockQuantity}
                                                </span>
                                            </td>
                                            <td>
                                                <span className="fw-bold fs-6">{item.stockQuantity}</span>
                                            </td>
                                            <td>
                                                <div className='d-flex flex-column w-100 me-2'>
                                                    <div className='d-flex flex-stack mb-2'>
                                                        <span className='text-muted me-2 fs-7 fw-semibold'>{progressPercentage(item)}</span>
                                                    </div>
                                                    <div className='progress h-6px w-100'>
                                                        <div
                                                            className={`progress-bar ${progressColorClass(item.stockColor)} `}
                                                            role='progressbar'
                                                            style={{ width: progressPercentage(item) }}
                                                        ></div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='d-flex justify-content-end flex-shrink-0'>
                                                    <button
                                                        className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                                                        onClick={() => handleEditClick(item)}
                                                        title={intl.formatMessage({ id: 'STOCK.FIELD.EDIT' })}
                                                    >
                                                        <KTIcon iconName='pencil' className='fs-3' />
                                                    </button>
                                                    <Link
                                                        to={`/stock-management/stocks/${item.id}`}
                                                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                        title={intl.formatMessage({ id: 'STOCK.FIELD.ACTIONS' })}
                                                    >
                                                        <KTIcon iconName='arrow-right' className='fs-3' />
                                                    </Link>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })}

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {renderEditModal()}
            {(loading || productLoading) && <Loader></Loader>}
        </>
    );
};



const mapStateToProps = state => {
    return {
        variantList: state.Stock.variantList,
        loading: state.Stock.loading,
        success: state.Stock.success,
        productSuccess: state.Product.success,
        productLoading: state.Product.loading
    };
};

const mapActionsToProps = {
    clearState, getVariantList, postStock, patchVariant, clearProductState
}

export default connect(mapStateToProps, mapActionsToProps)(Stocks)
